import { Stack } from '@mantine/core';
import type { FamilyMeeting } from 'src/meetings/hooks/useScopedMeetings';
import type { MeetingScope } from 'src/meetings/scope';
import { MeetingAgendaCard } from './MeetingAgendaCard';
import type { MeetingOverview } from './meetingOverviews';
import { MeetingOverviewCard } from './MeetingOverviewCard';
import { ParticipantInfoCard } from './ParticipantInfoCard';

type ParticipantInfo = {
  id: string;
  firstName: string;
  name: string;
  address: string | null;
  email: string | null;
  phone: string | null;
};

type Props = {
  overviews: MeetingOverview[];
  participantInfo: ParticipantInfo[];
  scope: MeetingScope;
  meeting: FamilyMeeting;
};

export function MeetingPreparation({ overviews, participantInfo, scope, meeting }: Props) {
  return (
    <Stack gap="sm">
      {overviews.map(overview => (
        <MeetingOverviewCard
          key={overview.key}
          subject={overview.subject}
          title={`${overview.name} overview`}
        />
      ))}

      {participantInfo.map(participant => (
        <ParticipantInfoCard
          key={participant.id}
          name={participant.name}
          address={participant.address}
          email={participant.email}
          phone={participant.phone}
        />
      ))}

      <MeetingAgendaCard scope={scope} meeting={meeting} />
    </Stack>
  );
}
